import React, {Component} from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';

const S = styled.span`
  margin: 0;
  padding: 0;
  position: absolute;
  height: 0;
  overflow: hidden;
  white-space: pre;
`
class MyInput extends Component {
  state={ value: this.props.value || " " }
  handleChange = e => {
    this.setState({ value: e.target.value })
  }
  render () {
    const { value } = this.state;
    const { id,label="",className } = this.props;
    const hVal = label.toString().length > value.toString().length ? (
      label ) : value
    return (
      <span className={className}>
        <S ref={i => this.sp=i}>
        {hVal}
        </S>
        <TextField
          id={id}
          label={label}
          value={value}
          onChange={this.handleChange}
          margin="normal"
          InputProps={{
            readOnly: true,
          }}
          style={{
            width: this.sp ? this.sp.offsetWidth + 15 : "40px"
          }}
        />
      </span>
    )
  }
}

export default MyInput
